import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from 'misc/env';
import DocumentAccess from './DocumentAccess';
import { DocumentAccessAPI } from './API';
var DocumentAccessStore = /*#__PURE__*/function (_Store) {
  function DocumentAccessStore() {
    var _this;
    _classCallCheck(this, DocumentAccessStore);
    _this = _callSuper(this, DocumentAccessStore, arguments);
    _this.accesses = _this.collection({
      model: DocumentAccess
    });
    _this.onDocumentCreated = function (data) {
      _this.accesses.set(data.accesses);
    };
    _this.api = new DocumentAccessAPI({
      baseURL: env.DOCUMENT_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.onRemoteAccessCreate = _this.onRemoteAccessCreate.bind(_this);
    _this.rootStore.authStore.onLogin(function () {
      _this.api.subscribe('AccessCreated', _this.onRemoteAccessCreate);
      _this.api.subscribe('AccessUpdated', _this.accesses.set);
      _this.api.subscribe('AccessDeleted', function (data) {
        return _this.accesses.remove(data.id);
      });
      _this.api.subscribe('DocumentCreated', _this.onDocumentCreated);
    });
    return _this;
  }
  _inherits(DocumentAccessStore, _Store);
  return _createClass(DocumentAccessStore, [{
    key: "onRemoteAccessCreate",
    value: function () {
      var _onRemoteAccessCreate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var access;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              access = this.accesses.set(data); // When an AccessCreated event is pushed to us, we might not have the
              // latest version of the document in the store if we are not the owner
              // of the document.
              if (!(!access.document || !access.document.owner || !access.document.owner.isCurrentUser)) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return this.rootStore.documentStore.fetchDocument(access.documentId);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onRemoteAccessCreate(_x) {
        return _onRemoteAccessCreate.apply(this, arguments);
      }
      return onRemoteAccessCreate;
    }()
  }, {
    key: "createAccess",
    value: function () {
      var _createAccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(documentId, data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.create(_objectSpread({
                document_id: documentId
              }, data)).then(this.accesses.set));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createAccess(_x2, _x3) {
        return _createAccess.apply(this, arguments);
      }
      return createAccess;
    }()
  }, {
    key: "updateAccess",
    value: function () {
      var _updateAccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(accessId, data) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.update(accessId, data).then(this.accesses.set));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateAccess(_x4, _x5) {
        return _updateAccess.apply(this, arguments);
      }
      return updateAccess;
    }()
  }, {
    key: "deleteAccess",
    value: function () {
      var _deleteAccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(accessId) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.api.delete(accessId).then(function () {
                return _this2.accesses.remove(accessId);
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteAccess(_x6) {
        return _deleteAccess.apply(this, arguments);
      }
      return deleteAccess;
    }()
  }]);
}(Store);
export { DocumentAccessStore as default };
//# sourceMappingURL=DocumentAccessStore.js.map
